const AuthHeader = ({ pageData }) => {
  return <h1 className="auth__header">{pageData?.header}</h1>;
};

export default AuthHeader;
